import { Button, type ButtonProps } from 'antd';
import { useTranslation } from 'react-i18next';

export interface IInquiryFilterRemoveButtonProps extends ButtonProps {}

/**
 * Pulsante per azzerare i filtri di ricerca delle domande.
 */
export function InquiryFilterRemoveButton(
  props: IInquiryFilterRemoveButtonProps,
) {
  const { t } = useTranslation();

  return (
    <Button {...props}>
      {t('domande.lista.pulsante.rimuovi-filtri', 'Rimuovi filtri')}
    </Button>
  );
}
